import R from 'ramda';
import isServer from '@cotyorg/ccx-utils/js/helpers/isServer';
import handleErrorUncurried from '../hocs/handleError';
import Placeholder from '../components/Placeholder';

const packagePath = '@cotyorg/ccx-server/router';

export const buildPreloadedState = (buildPreloadedStateOverride, componentKey) => {
  // Preloaded state is only built on server side
  if (!isServer) {
    return undefined;
  }

  if (buildPreloadedStateOverride) {
    return buildPreloadedStateOverride;
  }

  // TODO: Throw error when no buildPreloadedStateOverride supplied
  console.debug(`No buildPreloadedStateOverride supplied for ${componentKey}`);
  return undefined;
};

export const component = (componentOverride, handleError) => (
  componentOverride ? handleError(componentOverride) : handleError(Placeholder)
);

export const hasNeededRouteKeys = (route = {}) => !!(
  route.path &&
  route.id &&
  route.title &&
  route.component &&
  // NB: buildPreloadedState will be undefined on client side if webpack configured correctly
  (route.buildPreloadedState || !isServer)
);

export const reduceAdditionalRoutesToSanitized =
  (ErrorComponent, NotFoundComponent) => (additionalRoutesAcc, additionalRoute = {}) => {
    if (!hasNeededRouteKeys(additionalRoute)) {
      // eslint-disable-next-line no-console
      console.debug(`
        ${packagePath}: Invalid additional route "${additionalRoute.id}" supplied to router.
        Required route keys are: path, id, title, component, buildPreloadedState.importPath and
        buildPreloadedState.importKey.
      `);
      return additionalRoutesAcc;
    }

    const handleError = handleErrorUncurried(ErrorComponent, NotFoundComponent);

    return R.concat(
      additionalRoutesAcc,
      [
        {
          ...additionalRoute,
          component: component(additionalRoute.component, handleError, additionalRoute.id),
          buildPreloadedState: isServer ? (
            additionalRoute.buildPreloadedState
          ) : (
            undefined
          ),
        },
      ],
    );
  };

export const sanitizeAdditionalRoutes = (additionalRoutes, ErrorComponent, NotFoundComponent) => {
  if (!Array.isArray(additionalRoutes)) {
    // eslint-disable-next-line no-console
    console.debug(`${packagePath}: Invalid additional routes supplied to router.`);
    return [];
  }

  return R.reduce(reduceAdditionalRoutesToSanitized(ErrorComponent, NotFoundComponent), [], additionalRoutes);
};
